import PropTypes from 'prop-types'

const paginationType = PropTypes.shape({
  number: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
})

export default paginationType
